import { WindowService } from '../../shared/services/window.service';
import { serviceWorkerApiAvailableFactory } from '../service-worker-api-available.factory';

export function encryptedServiceWorkerApiAvailableFactory(
    windowService: WindowService,
    platformId: string,
    cryptoApiAvailable: boolean
) {
    // Run the regular ServiceWorkerModule factory for detecting if the Service Worker API is available
    return cryptoApiAvailable && serviceWorkerApiAvailableFactory(windowService, platformId);
}
